module.exports = __webpack_public_path__ + "img/lancamentos-home-buildings.e57ec720.webp";